/* @flow */
import { socialActionMaker } from '@website/components/ActionMakers'
import { addSocial } from '@website/components/CommonActions'

export default dispatcher => ({
  addSocial: () => dispatcher(addSocial()),
  getSocialActions: socialActionMaker(dispatcher)
})
